<template>
	<card-component
	ref="card"
	:model="['knd_form_01', 'knd/knd_forms_01/' + departmentId + '/' + year + '/' + month]"
	:id="itemId"
	:required-fields="requiredFields"
	:custom-back-url="'/knd/knd_forms_01/' + this.$route.params.departmentid + '/' + this.$route.params.year"
	:custom-buttons="customButtons"
	v-on:preview="previewClicked"
	:fields-list="[
		'department',
		'form_date',
		'form_data',
		'form_period'
	]"
	:fields-prefill="[
		['form_period', formPeriod],
		['department', departmentId],
		['form_date', formDate],
		['form_data', {
			inspectors: '',
			arrested: { vbr: '', net_fishing_gears: '', other_fishing_gears: '', vehicles: '' }, 
			penalty_issued: { total: '', fishing: '', vbr: '', authority: '', safety: '' }, 
			protocols_count: { total: '', fishing: '', vbr: '', authority: '', safety: '' }, 
			penalty_collected: { total: '', fishing: '', vbr: '', authority: '', safety: '' }, 
			damage_sum_claimed: { total: '', fishery_violations: '' }, 
			damage_sum_collected: {	total: '', fishery_violations: '' }, 
			opened_criminal_cases: { cases: '', persons: '' }, 
			sent_to_consideration: { cases: '', persons: '' }
		}]
	]"
	>
		<template v-slot:card="slotProps">
			<div>
				<div v-if="slotProps.mode === 'edit'" class="pt-4 px-4">
					<div class="alert alert-info m-0 d-flex">
						<div class="mr-2">
							<span class="fal fa-file-spreadsheet fa-fw fa-2x"></span>
						</div>
						<div>
							<input class="custom-field" type="file" @change="onChange" />
							<xlsx-read :file="file" @parsed="fileParsed">
								<template #default="{loading}">
								  	<span v-if="loading">Чтение файла...</span>
								</template>
							</xlsx-read>

							<div class="d-flex mt-2" v-if="parsedFile">
								<select class="custom-select" v-model="selectedSheet" v-if="parsedFile" placeholder="Выберите лист">
									<option v-for="sheet in Object.keys(parsedFile.Sheets)" :value="sheet">
										{{ sheet }}
									</option>
								</select>
								<select class="custom-select ml-2" v-model="selectedDepartment" v-if="parsedFile && selectedSheet" placeholder="Выберите строку управления">
									<option v-for="sheet in departmentsRows" :value="sheet.row">
										{{ sheet.title }}
									</option>
								</select>
								<button v-if="parsedFile && selectedSheet && selectedDepartment" class="ml-2 btn btn-primary" @click.prevent="pasteData">
									<nobr>Вставить данные</nobr>
								</button>
							</div>	
						</div>
					</div>
				</div>
				<div class="card-body">
					<b-row class="m-0">
						<b-col cols="12" md="4" lg="3" v-if="slotProps.mode === 'show'">
							<card-field-component
							type="entity:department"
							title="Территориальное управление"
							v-model="slotProps.editableItem.department"
							fieldname="department"
							:errors="slotProps.errors"
							:disabled="true"
							:mode="'show'"
							v-on:update:value="slotProps.editableItem.department = $event"
							:is-required="requiredFields.some(o => o[0] === 'department')"
							/>
						</b-col>
						<b-col cols="12" md="4" lg="3">
							<card-field-component
							type="date_month"
							title="Отчетный период"
							fieldname="form_period"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_period"
							:display-value="slotProps.item.form_period"
							:disabled="true"
							:month-only="true"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_period = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_period')"
							/>
						</b-col>
						<b-col cols="12" md="4" lg="3">
							<card-field-component
							type="date"
							title="Дата заполнения формы"
							fieldname="form_date"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_date"
							:display-value="slotProps.item.form_date"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_date = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_date')"
							/>
						</b-col>
						<!-- <b-col cols="12" md="4" lg="3">
							<card-field-component
							type="text"
							title="Имя отчёта"
							fieldname="title"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.title"
							:display-value="slotProps.item.title"
							:disabled="slotProps.fetching"
							:year-only="true"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.title = $event"
							/>
						</b-col> -->
					</b-row>
					<b-row class="m-0">
						<b-col cols="12" md="4" lg="3">
							<card-field-component
							type="number"
							title="Численность инспекторов"
							fieldname="form_data.inspectors"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.inspectors"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.inspectors : slotProps.editableItem.form_data.inspectors"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.inspectors = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.inspectors')"
							/>
						</b-col>
					</b-row>
					<div class="p-3">
						<h6 class="text-dark">
							Количество протоколов
						</h6>
					</div>
					<b-row class="m-0">
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number"
							title="Всего"
							fieldname="form_data.protocols_count.total"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.protocols_count.total"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.protocols_count.total : slotProps.editableItem.form_data.protocols_count.total"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.protocols_count.total = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.protocols_count.total')"
							/>
						</b-col>
						<b-col cols="12" md="4" lg="6">
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number"
							title="Нарушения в области рыболовства"
							fieldname="form_data.protocols_count.fishing"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.protocols_count.fishing"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.protocols_count.fishing : slotProps.editableItem.form_data.protocols_count.safety"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.protocols_count.fishing = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.protocols_count.fishing')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number"
							title="Нарушения в области сохранения ВБР"
							fieldname="form_data.protocols_count.vbr"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.protocols_count.vbr"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.protocols_count.vbr : slotProps.editableItem.form_data.protocols_count.authority"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.protocols_count.vbr = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.protocols_count.vbr')"
							/>
						</b-col>
						<b-col class="col-lg-4 d-none d-lg-block">
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number"
							title="Нарушения, посягающие на органы гос. власти, против порядка управления, общественного порядка и общественной безопасности"
							fieldname="form_data.protocols_count.authority"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.protocols_count.authority"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.protocols_count.authority : slotProps.editableItem.form_data.protocols_count.vbr"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.protocols_count.authority = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.protocols_count.authority')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number"
							title="Нарушения правил безопасности на водном транспорте"
							fieldname="form_data.protocols_count.safety"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.protocols_count.safety"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.protocols_count.safety : slotProps.editableItem.form_data.protocols_count.fishing"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.protocols_count.safety = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.protocols_count.safety')"
							/>
						</b-col>
					</b-row>
					<div class="p-3">
						<h6 class="text-dark">
							Наложено штрафов
						</h6>
					</div>
					<b-row class="m-0">
						<b-col cols="4">
							<card-field-component
							type="number_money"
							title="Всего"
							fieldname="form_data.penalty_issued.total"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_issued.total"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_issued.total : slotProps.editableItem.form_data.penalty_issued.total"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_issued.total = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_issued.total')"
							/>
						</b-col>
						<b-col cols="6">
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Нарушения в области рыболовства"
							fieldname="form_data.penalty_issued.fishing"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_issued.fishing"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_issued.fishing : slotProps.editableItem.form_data.penalty_issued.safety"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_issued.fishing = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_issued.fishing')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Нарушения в области сохранения ВБР"
							fieldname="form_data.penalty_issued.vbr"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_issued.vbr"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_issued.vbr : slotProps.editableItem.form_data.penalty_issued.authority"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_issued.vbr = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_issued.vbr')"
							/>
						</b-col>
						<b-col class="col-lg-4 d-none d-lg-block">
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Нарушения, посягающие на органы гос. власти, против порядка управления, общественного порядка и общественной безопасности"
							fieldname="form_data.penalty_issued.authority"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_issued.authority"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_issued.authority : slotProps.editableItem.form_data.penalty_issued.vbr"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_issued.authority = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_issued.authority')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Нарушения правил безопасности на водном транспорте"
							fieldname="form_data.penalty_issued.safety"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_issued.safety"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_issued.safety : slotProps.editableItem.form_data.penalty_issued.fishing"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_issued.safety = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_issued.safety')"
							/>
						</b-col>
					</b-row>
					<div class="p-3">
						<h6 class="text-dark">
							Взыскано штрафов
						</h6>
					</div>
					<b-row class="m-0">
						<b-col cols="4">
							<card-field-component
							type="number_money"
							title=" Всего"
							fieldname="form_data.penalty_collected.total"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_collected.total"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_collected.total : slotProps.editableItem.form_data.penalty_collected.total"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_collected.total = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_collected.total')"
							/>
						</b-col>
						<b-col cols="6">
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Нарушения в области рыболовства"
							fieldname="form_data.penalty_collected.fishing"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_collected.fishing"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_collected.fishing : slotProps.editableItem.form_data.penalty_collected.safety"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_collected.fishing = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_collected.fishing')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Нарушения в области сохранения ВБР"
							fieldname="form_data.penalty_collected.vbr"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_collected.vbr"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_collected.vbr : slotProps.editableItem.form_data.penalty_collected.authority"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_collected.vbr = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_collected.vbr')"
							/>
						</b-col>
						<b-col class="col-lg-4 d-none d-lg-block">
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Нарушения, посягающие на органы гос. власти, против порядка управления, общественного порядка и общественной безопасности"
							fieldname="form_data.penalty_collected.authority"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_collected.authority"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_collected.authority : slotProps.editableItem.form_data.penalty_collected.vbr"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_collected.authority = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_collected.authority')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Нарушения правил безопасности на водном транспорте"
							fieldname="form_data.penalty_collected.safety"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.penalty_collected.safety"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.penalty_collected.safety : slotProps.editableItem.form_data.penalty_collected.fishing"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.penalty_collected.safety = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.penalty_collected.safety')"
							/>
						</b-col>
					</b-row>
					<div class="p-3">
						<h6 class="text-dark">
							Сумма предъявленного ущерба, тыс. руб.
						</h6>
					</div>
					<b-row class="m-0">						
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Всего"
							fieldname="form_data.damage_sum_claimed.total"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.damage_sum_claimed.total"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.damage_sum_claimed.total : slotProps.editableItem.form_data.damage_sum_claimed.total"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.damage_sum_claimed.total = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.damage_sum_claimed.total')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="В том числе, за нарушения в области рыболовства"
							fieldname="form_data.damage_sum_claimed.fishery_violations"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.damage_sum_claimed.fishery_violations"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.damage_sum_claimed.fishery_violations : slotProps.editableItem.form_data.damage_sum_claimed.fishery_violations"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.damage_sum_claimed.fishery_violations = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.damage_sum_claimed.fishery_violations')"
							/>
						</b-col>
					</b-row>
					<div class="p-3">
						<h6 class="text-dark">
							Сумма взысканного ущерба, тыс. руб.
						</h6>
					</div>
					<b-row class="m-0">						
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="Всего"
							fieldname="form_data.damage_sum_collected.total"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.damage_sum_collected.total"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.damage_sum_collected.total : slotProps.editableItem.form_data.damage_sum_collected.total"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.damage_sum_collected.total = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.damage_sum_collected.total')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_money"
							title="В том числе, за нарушения в области рыболовства"
							fieldname="form_data.damage_sum_collected.fishery_violations"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.damage_sum_collected.fishery_violations"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.damage_sum_collected.fishery_violations : slotProps.editableItem.form_data.damage_sum_collected.fishery_violations"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.damage_sum_collected.fishery_violations = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.damage_sum_collected.fishery_violations')"
							/>
						</b-col>
					</b-row>
					<div class="p-3">
						<h6 class="text-dark">
							Направлено материалов на рассмотрение в следственные органы
						</h6>
					</div>
					<b-row class="m-0">						
						<b-col cols="12" md="6" lg="2">
							<card-field-component
							type="number"
							title="Дел"
							fieldname="form_data.sent_to_consideration.cases"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.sent_to_consideration.cases"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.sent_to_consideration.cases : slotProps.editableItem.form_data.sent_to_consideration.cases"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.sent_to_consideration.cases = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.sent_to_consideration.cases')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="2">
							<card-field-component
							type="number"
							title="Человек"
							fieldname="form_data.sent_to_consideration.persons"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.sent_to_consideration.persons"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.sent_to_consideration.persons : slotProps.editableItem.form_data.sent_to_consideration.persons"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.sent_to_consideration.persons = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.sent_to_consideration.persons')"
							/>
						</b-col>
					</b-row>
					<div class="p-3">
						<h6 class="text-dark">
							Возбуждено уголовных дел по направленным материалам
						</h6>
					</div>
					<b-row class="m-0">						
						<b-col cols="12" md="6" lg="2">
							<card-field-component
							type="number"
							title="Дел"
							fieldname="form_data.opened_criminal_cases.cases"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.opened_criminal_cases.cases"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.opened_criminal_cases.cases : slotProps.editableItem.form_data.opened_criminal_cases.cases"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.opened_criminal_cases.cases = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.opened_criminal_cases.cases')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="2">
							<card-field-component
							type="number"
							title="Человек"
							fieldname="form_data.opened_criminal_cases.persons"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.opened_criminal_cases.persons"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.opened_criminal_cases.persons : slotProps.editableItem.form_data.opened_criminal_cases.persons"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.opened_criminal_cases.persons = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.opened_criminal_cases.persons')"
							/>
						</b-col>
					</b-row>
					<div class="p-3">
						<h6 class="text-dark">
							Изъято, арестовано
						</h6>
					</div>
					<b-row class="m-0">
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number_weight"
							title="ВБР, т"
							fieldname="form_data.arrested.vbr"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.arrested.vbr"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.arrested.vbr : slotProps.editableItem.form_data.arrested.vbr"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.arrested.vbr = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.arrested.vbr')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number"
							title="Сетных орудий лова, ед."
							fieldname="form_data.arrested.net_fishing_gears"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.arrested.net_fishing_gears"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.arrested.net_fishing_gears : slotProps.editableItem.form_data.arrested.net_fishing_gears"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.arrested.net_fishing_gears = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.arrested.net_fishing_gears')"
							/>
						</b-col>
						<b-col class="col-lg-4 d-none d-lg-block">
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number"
							title="Других орудий лова, ед."
							fieldname="form_data.arrested.other_fishing_gears"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.arrested.other_fishing_gears"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.arrested.other_fishing_gears : slotProps.editableItem.form_data.arrested.other_fishing_gears"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.arrested.other_fishing_gears = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.arrested.other_fishing_gears')"
							/>
						</b-col>
						<b-col cols="12" md="6" lg="4">
							<card-field-component
							type="number"
							title="Транспортных средств, лодочных моторов, ед."
							fieldname="form_data.arrested.vehicles"
							:errors="slotProps.errors"
							v-model="slotProps.editableItem.form_data.arrested.vehicles"
							:display-value="slotProps.item.form_data ? slotProps.item.form_data.arrested.vehicles : slotProps.editableItem.form_data.arrested.vehicles"
							:disabled="slotProps.fetching"
							:mode="slotProps.mode"
							v-on:update:value="slotProps.editableItem.form_data.arrested.vehicles = $event"
							:is-required="requiredFields.some(o => o[0] === 'form_data.arrested.vehicles')"
							/>
						</b-col>
					</b-row>
				</div>
			</div>
			<div>
				<b-modal :ok-disabled="true" hide-footer ref="modal" size="xl" title="Просмотр отчета">
					<knd-form-01-table
					ref="KndForm01Table" 
					v-if="itemId !== 'create'"
					:kndform01id="itemId"
					v-on:refetch="refetch"
					>
					</knd-form-01-table>
					<template slot="modal-cancel">
						Закрыть
					</template>
					<template class="disabled" slot="modal-ok">
						Печать
						<span class="far fa-print fa-fw"></span> 
					</template>
				</b-modal>

			</div>
		</template>
	</card-component>
</template>


<script>
import KndForm01Table from '@/views/knd/knd_form_01/KndForm01Table'
import moment from 'moment'
export default {
	props: [
	],
	components: {
		'knd-form-01-table': KndForm01Table,
	},
	data () {
		return {
			file: null,
			parsedFile: null,
			selectedSheet: null,
			selectedDepartment: null,
			sheetName: null,
			collection: [{ a: 1, b: 2 }],
			requiredFields: [
				// ['department', 'Территориальное управление'],
				['form_date', 'Дата формирования отчёта'],
				['form_period', 'Отчетный период'],
				['form_data.inspectors', 'Численность инспекторов'],
				['form_data.protocols_count.safety', 'Количество протоколов'],
				['form_data.protocols_count.authority', 'Количество протоколов'],
				['form_data.protocols_count.vbr', 'Количество протоколов'],
				['form_data.protocols_count.fishing', 'Количество протоколов'],
				['form_data.protocols_count.total', 'Количество протоколов, всего'],
				['form_data.penalty_issued.safety', 'Наложено штрафов'],
				['form_data.penalty_issued.authority', 'Наложено штрафов'],
				['form_data.penalty_issued.vbr', 'Наложено штрафов'],
				['form_data.penalty_issued.fishing', 'Наложено штрафов'],
				['form_data.penalty_issued.total', 'Наложено штрафов, всего'],
				['form_data.penalty_collected.safety', 'Взыскано штрафов'],
				['form_data.penalty_collected.authority', 'Взыскано штрафов'],
				['form_data.penalty_collected.vbr', 'Взыскано штрафов'],
				['form_data.penalty_collected.fishing', 'Взыскано штрафов'],
				['form_data.penalty_collected.total', 'Взыскано штрафов, всего'],
				['form_data.damage_sum_claimed.fishery_violations', 'Сумма предъявленного ущерба'],
				['form_data.damage_sum_claimed.total', 'Сумма предъявленного ущерба, всего'],
				['form_data.damage_sum_collected.fishery_violations', 'Сумма взысканного ущерба'],
				['form_data.damage_sum_collected.total', 'Сумма взысканного ущерба, всего'],
				['form_data.opened_criminal_cases.cases', 'Возбуждено уголовных дел'],
				['form_data.opened_criminal_cases.persons', 'Возбуждено уголовных дел, человек'],
				['form_data.sent_to_consideration.cases', 'Направлено материалов на рассмотрение, дел'],
				['form_data.sent_to_consideration.persons', 'Направлено материалов на рассмотрение, человек'],
				['form_data.arrested.vbr', 'Изъято, арестовано: ВБР'],
				['form_data.arrested.net_fishing_gears', 'Сетных орудий лова'],
				['form_data.arrested.other_fishing_gears', 'Других орудий лова'],
				['form_data.arrested.vehicles', 'Транспортных средств, лодочных моторов']
			],
			excelFields: [
				['', 'department', 'Территориальное управление'],
				['', 'form_date', 'Дата формирования отчёта'],
				['', 'form_period', 'Отчетный период'],
				['C', 'inspectors', 'Численность инспекторов'],
				['H', 'protocols_count.safety', 'Количество протоколов'],
				['G', 'protocols_count.authority', 'Количество протоколов'],
				['F', 'protocols_count.vbr', 'Количество протоколов'],
				['E', 'protocols_count.fishing', 'Количество протоколов'],
				['D', 'protocols_count.total', 'Количество протоколов, всего'],
				['M', 'penalty_issued.safety', 'Наложено штрафов'],
				['L', 'penalty_issued.authority', 'Наложено штрафов'],
				['K', 'penalty_issued.vbr', 'Наложено штрафов'],
				['J', 'penalty_issued.fishing', 'Наложено штрафов'],
				['I', 'penalty_issued.total', 'Наложено штрафов, всего'],
				['R', 'penalty_collected.safety', 'Взыскано штрафов'],
				['Q', 'penalty_collected.authority', 'Взыскано штрафов'],
				['P', 'penalty_collected.vbr', 'Взыскано штрафов'],
				['O', 'penalty_collected.fishing', 'Взыскано штрафов'],
				['N', 'penalty_collected.total', 'Взыскано штрафов, всего'],
				['T', 'damage_sum_claimed.fishery_violations', 'Сумма предъявленного ущерба'],
				['S', 'damage_sum_claimed.total', 'Сумма предъявленного ущерба, всего'],
				['V', 'damage_sum_collected.fishery_violations', 'Сумма взысканного ущерба'],
				['U', 'damage_sum_collected.total', 'Сумма взысканного ущерба, всего'],
				['Y', 'opened_criminal_cases.cases', 'Возбуждено уголовных дел'],
				['Z', 'opened_criminal_cases.persons', 'Возбуждено уголовных дел, человек'],
				['W', 'sent_to_consideration.cases', 'Направлено материалов на рассмотрение, дел'],
				['X', 'sent_to_consideration.persons', 'Направлено материалов на рассмотрение, человек'],
				['AA', 'arrested.vbr', 'Изъято, арестовано: ВБР'],
				['AB', 'arrested.net_fishing_gears', 'Сетных орудий лова'],
				['AC', 'arrested.other_fishing_gears', 'Других орудий лова'],
				['AD', 'arrested.vehicles', 'Транспортных средств, лодочных моторов']
			]
		}
	},
	mounted() {
	},
	computed: {
		customButtons () {
			return [
				{
					text: 'Просмотр',
					event: 'preview',
					icon: 'file-search',
					variant: 'info',
					visibleWhenNull: 'is_locked'
				}
			]
		},
		formPeriod () {
			return moment({ year: parseInt(this.year), month: parseInt(this.month)-1, day: 1}).toDate()
		},
		formDate () {
			return moment().format("YYYY-MM-DD")
		},
		departmentId () {
			return this.$route.params.departmentid
		},
		year () {
			return this.$route.params.year
		},
		month () {
			return this.$route.params.month
		},
		itemId () {
			return this.$route.params.kndform01id
		},
		departmentsRows () {
			let arr = []

			let depFieldsStart = 11

			for (var i = depFieldsStart; i < 29; i++) {
				let cell = this.parsedFile.Sheets[this.selectedSheet]['B' + i]
				arr.push({
					row: i,
					title: cell.v
				})
			}
			return arr
		}
	},
	methods: {
		fileParsed (book) {
			this.parsedFile = book
		},
		onChange (event) {
			this.file = event.target.files ? event.target.files[0] : null
		},
		previewClicked () {
			this.$refs.modal.show()
		},
		// Применение изменение к json/объекту с помощью
		// путей в строчках
		apply (data, mods) {
			for (var path in mods) {
				var k = data;
				var steps = path.split('.');
				var last = steps.pop();
				steps.forEach(e => (k[e] = k[e] || {}) && (k = k[e]));
				k[last] = mods[path];
			}
			return data
		},
		pasteData () {
			for (var i = this.excelFields.length - 1; i >= 0; i--) {
				let field = this.excelFields[i]
				if (field[0]) {
					// Получение значения из ячейки загруженного файла
					let cell = this.parsedFile.Sheets[this.selectedSheet][field[0] + this.selectedDepartment]
					let form_data = this.$refs.card.editableItem.form_data
					let dataPath = field[1]
					let modified = {}
					modified[dataPath] = cell.v
					// Модификация исходного form_data и отправка в форму
					this.$refs.card.setFieldValue('form_data', this.apply(form_data, modified))
				}
			}
		},
		refetch () {
		},
	}
}
</script>
